var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading",class:{ 'spinner-fade': !_vm.show }},[_vm._m(0),_c('div',{staticClass:"spinner-text"},[_vm._v("Building route...")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"spinner"},[_c('img',{attrs:{"src":require("@/static/favicon-64x64.png")}})])
}]

export { render, staticRenderFns }